import { ActionTypes } from "@/App/constants/actionTypes";
import { MigrateUserTypes } from "@/types";

type MigrateUserAction = {
  type: typeof ActionTypes.MIGRATE_USER;
  payload: MigrateUserTypes.MigrateUser;
};

export const migrateUser = (payload: MigrateUserTypes.MigrateUser): MigrateUserAction => {
  return {
    type: ActionTypes.MIGRATE_USER,
    payload: payload,
  };
};

type MigrateUserInformationAction = {
  type: typeof ActionTypes.MIGRATE_USER_INFORMATION;
  payload: MigrateUserTypes.MigrateUser;
};

export const migrateUserInformation = (payload: MigrateUserTypes.MigrateUser): MigrateUserInformationAction => {
  return {
    type: ActionTypes.MIGRATE_USER_INFORMATION,
    payload: payload,
  };
};

type MigrateUserResultAction = {
  type: typeof ActionTypes.MIGRATE_USER_RESULT;
};

export const migrateUserResult = (): MigrateUserResultAction => {
  return {
    type: ActionTypes.MIGRATE_USER_RESULT,
  };
};

export type MigrateUserActions = MigrateUserAction | MigrateUserInformationAction | MigrateUserResultAction;
